<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="tableColumns"
      border
      :data="tableElastiCacheData"
      :span-method="handleSpan"
      :disabled-hover="true"
    ></Table>
  </div>
</template>

<script>
import { getCookie } from "../../../utils/cookieUtil.js";
let tableElastiCacheTag = {};
export default {
  name: "TableElastiCache",
  data() {
    return {
      companyId: "",
      accountIds: [],
      projectTag: "",
      riDataSource: "",
      company: getCookie(global.companyId),
      tableColumns: [
        {
          title: this.$t('Bill.ResourceOptimization.customer'),
          key: "companyName"
        },
        {
          title: this.$t('alarms.queue.region'),
          key: "region"
        },
        {
          title: this.$t('Bill.ResourceOptimization.engineType'),
          key: "engine"
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticCache.CacheNodeType"),
          key: "cacheNodeType"
        },
        {
          title: this.$t('Bill.ResourceOptimization.elasticsearchCount'),
          key: "instanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.RIRecommendedQuantity'),
          key: "longTimeInstanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.RIAvailableQuantity'),
          key: "reservedInstanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.purchaseRate'),
          key: "purchaseRate"
        },
        {
          title: this.$t('Bill.ResourceOptimization.exactlyMatchTheSavings'),
          key: "matchSaveCose",
          renderHeader: (h, params) => {
            return h("div", [
              h("span", this.$t('Bill.ResourceOptimization.exactlyMatchTheSavings')),
              h(
                "Tooltip",
                {
                  props: { placement: "top", transfer: true, maxWidth: "200" }
                },
                [
                  [
                    h(
                      "p",
                      { slot: "content" },
                      this.$t('Bill.ResourceOptimization.toolTips')
                    )
                  ],
                  [
                    h("Icon", {
                      props: { type: "md-help-circle" },
                      style: { color: "red", fontSize: "16px" }
                    })
                  ]
                ]
              )
            ]);
          }
        },
        {
          title: this.$t('Bill.ResourceOptimization.currentlyReservedToSaveCosts'),
          key: "riSaveCost",
          renderHeader: (h, params) => {
            return h("div", [
              h("span", this.$t('Bill.ResourceOptimization.currentlyReservedToSaveCosts')),
              h(
                "Tooltip",
                {
                  props: { placement: "top", transfer: true, maxWidth: "200" }
                },
                [
                  [
                    h(
                      "p",
                      { slot: "content" },
                      this.$t('Bill.ResourceOptimization.toolTips')
                    )
                  ],
                  [
                    h("Icon", {
                      props: { type: "md-help-circle" },
                      style: { color: "red", fontSize: "16px" }
                    })
                  ]
                ]
              )
            ]);
          }
        }
      ],
      tableElastiCacheData: []
    };
  },
  beforeCreate: function() {
    tableElastiCacheTag = this;
  },
  methods: {
    // 查询条件
    showElastiCacheAll: function(
      companyId,
      accountIds,
      projectTag,
      riDataSource
    ) {
      tableElastiCacheTag.projectTag = projectTag;
      tableElastiCacheTag.companyId = companyId;
      tableElastiCacheTag.accountIds = accountIds;
      tableElastiCacheTag.riDataSource = riDataSource;
      tableElastiCacheTag.getData();
    },
    // 显示数据
    getData: function() {
      tableElastiCacheTag.$api.resourceOptimize
        .resourceOptimizationElasticacheDashboard({
          companyId:
            this.companyId == null ||
            this.companyId == "" ||
            this.companyId == undefined
              ? this.company
              : this.companyId,
          projectTag: this.projectTag,
          accountIds: this.accountIds,
          riDataSource: this.riDataSource
        })
        .then(res => {
          this.assembleData(res.data);
        });
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      // 客户列
      if (columnIndex == 0) {
        let x = row.companyNameNum == 0 ? 0 : row.companyNameNum;
        let y = row.companyNameNum == 0 ? 0 : 1;
        return [x, y];
      }
      // 区域列
      if (columnIndex == 1) {
        let x = row.regionNum == 0 ? 0 : row.regionNum;
        let y = row.regionNum == 0 ? 0 : 1;
        return [x, y];
      }
      // 引擎类型列
      if (columnIndex == 2) {
        let x = row.engineNum == 0 ? 0 : row.engineNum;
        let y = row.engineNum == 0 ? 0 : 1;
        return [x, y];
      }
    },
    assembleData(data) {
      // 数据处理算法，处理后，便于单元格的合并
      for (var i = 0; i < data.length; i++) {
        if (data[i].companyNameAlready !== 1) {
          if (data[i + 1]) {
            data[i].companyNameNum = 1;
            for (var j = i + 1; j < data.length; j++) {
              if (data[i].companyName === data[j].companyName) {
                data[i].companyNameNum++;
                data[j].companyNameNum = 0;
                data[j].companyNameAlready = 1;
              } else {
                break;
              }
            }
          }
        }
      }

      for (var k = 0; k < data.length; k++) {
        if (data[k].companyNameNum > 1) {
          for (var m = 0; m < data[k].companyNameNum; m++) {
            if (data[k + m].regionAlready !== 1) {
              if (m + 1 < data[k].companyNameNum) {
                data[k + m].regionNum = 1;
                for (var n = m + 1; n < data[k].companyNameNum; n++) {
                  if (data[k + m].region === data[k + n].region) {
                    data[k + m].regionNum++;
                    data[k + n].regionNum = 0;
                    data[k + n].regionAlready = 1;
                  } else {
                    break;
                  }
                }
              }
            }
          }
        }
      }

      for (var l = 0; l < data.length; l++) {
        if (data[l].regionNum > 1) {
          for (var p = 0; p < data[l].regionNum; p++) {
            if (data[l + p].engineAlready !== 1) {
              if (p + 1 < data[l].regionNum) {
                data[l + p].engineNum = 1;
                for (var z = p + 1; z < data[l].regionNum; z++) {
                  if (data[l + p].engine === data[l + z].engine) {
                    data[l + p].engineNum++;
                    data[l + z].engineNum = 0;
                    data[l + z].engineAlready = 1;
                  } else {
                    break;
                  }
                }
              }
            }
          }
        }
      }
      this.tableElastiCacheData = data;
    }
  }
};
</script>
<style>
.green {
  background-color: #187 !important;
  color: #fff;
  font-weight: 600;
  border: none;
}
.red {
  background-color: #d22828 !important;
  color: #fff;
  font-weight: 600;
  border: none;
}
.yellow {
  background-color: yellow !important;
  border: none;
  color: #000;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/resource_optimization/TableElastiCache.vue